$(document).ready(function () {
  let p = $("body").attr("p");

  if (p == "events") {
    const LONG_PRESS_CONFIG = {
      duration: 1000,
      moveThreshold: 10,
    };

    let isScrolling = false;
    let scrollTimeout;
    let lastScrollTop = 0;
    let hasScrolledDuringTouch = false;

    class LongPressHandler {
      constructor(element) {
        this.element = element;
        this.timer = null;
        this.startPos = { x: 0, y: 0 };
        this.isActive = false;
        this.isLongPressed = false;
      }

      start(e) {
        if (isScrolling || hasScrolledDuringTouch) {
          return;
        }

        this.reset();
        this.isActive = true;
        this.isLongPressed = false;

        const touch = e.type.includes("touch") ? e.originalEvent.touches[0] : e;
        this.startPos = {
          x: touch.clientX || touch.pageX,
          y: touch.clientY || touch.pageY,
        };

        this.timer = setTimeout(() => {
          if (this.isActive && !isScrolling && !hasScrolledDuringTouch) {
            this.triggerLongPress();
          }
        }, LONG_PRESS_CONFIG.duration);
      }

      move(e) {
        if (!this.isActive || isScrolling || hasScrolledDuringTouch) return;

        const touch = e.type.includes("touch") ? e.originalEvent.touches[0] : e;
        const currentPos = {
          x: touch.clientX || touch.pageX,
          y: touch.clientY || touch.pageY,
        };

        const distance = Math.sqrt(
          Math.pow(currentPos.x - this.startPos.x, 2) +
            Math.pow(currentPos.y - this.startPos.y, 2)
        );

        if (distance > LONG_PRESS_CONFIG.moveThreshold) {
          this.cancel();
        }
      }

      end() {
        const wasLongPressed = this.isLongPressed;
        this.cancel();
        return wasLongPressed;
      }

      cancel() {
        if (this.timer) {
          clearTimeout(this.timer);
          this.timer = null;
        }
        this.isActive = false;
      }

      reset() {
        this.cancel();
        this.isLongPressed = false;
      }

      triggerLongPress() {
        this.isLongPressed = true;
        this.isActive = false;

        const productId = this.element.attr("id").split("-")[1];
        this.showProductDetails(productId);
      }

      showProductDetails(productId) {
        $.ajax({
          type: "POST",
          url: "/api/v1/private/products/get-product-details",
          data: { product_id: productId },
          timeout: 10000,
        })
          .done(function (data) {
            if (data.html !== undefined && data.html !== null) {
              $("#content").append(data.html);
              $("#product-details-modal").modal("show");
            }
          })
          .fail(function (xhr) {
            console.error("Failed to load product details:", xhr);
            if (xhr.responseJSON?.redirect_url) {
              window.location.href = xhr.responseJSON.redirect_url;
            }
          });
      }
    }

    const longPressHandlers = new WeakMap();

    function detectScrollStart() {
      isScrolling = true;
      hasScrolledDuringTouch = true;

      // Cancel all active long press handlers when scrolling starts
      $(".shop-product-container .shop-product").each(function () {
        const handler = longPressHandlers.get(this);
        if (handler) {
          handler.cancel();
        }

        $(this).removeData("wasLongPressed lastTap");
      });
    }

    function detectScrollEnd() {
      clearTimeout(scrollTimeout);
      scrollTimeout = setTimeout(() => {
        isScrolling = false;
      }, 100);
    }

    $(window).on("scroll.longpress", function () {
      const currentScrollTop = $(this).scrollTop();
      if (Math.abs(currentScrollTop - lastScrollTop) > 1) {
        if (!isScrolling) {
          detectScrollStart();
        }
        lastScrollTop = currentScrollTop;
      }
      detectScrollEnd();
    });

    $(document).on(
      "scroll.longpress",
      ".shop-product-container, .product-list, [data-scroll]",
      function (e) {
        const currentScrollTop = $(this).scrollTop();
        if (Math.abs(currentScrollTop - lastScrollTop) > 1) {
          if (!isScrolling) {
            detectScrollStart();
          }
          lastScrollTop = currentScrollTop;
        }
        detectScrollEnd();
      }
    );

    let touchStartY = 0;
    let touchStartX = 0;
    let touchMoveThreshold = 2;

    $(document).on("touchstart.scroll", function (e) {
      touchStartY = e.originalEvent.touches[0].clientY;
      touchStartX = e.originalEvent.touches[0].clientX;
      hasScrolledDuringTouch = false;
    });

    $(document).on("touchmove.scroll", function (e) {
      const touchY = e.originalEvent.touches[0].clientY;
      const touchX = e.originalEvent.touches[0].clientX;
      const deltaY = Math.abs(touchY - touchStartY);
      const deltaX = Math.abs(touchX - touchStartX);

      if (deltaY > touchMoveThreshold || (deltaY > 1 && deltaY > deltaX)) {
        if (!isScrolling) {
          detectScrollStart();
        }
      }
      detectScrollEnd();
    });

    function getLongPressHandler(element) {
      const $element = $(element);
      if (!longPressHandlers.has(element)) {
        longPressHandlers.set(element, new LongPressHandler($element));
      }
      return longPressHandlers.get(element);
    }

    $(document)
      .on(
        "mousedown.longpress touchstart.longpress",
        ".shop-product-container .shop-product",
        function (e) {
          if (isScrolling || hasScrolledDuringTouch) {
            return;
          }

          if ($(this).hasClass("sub_product_category_card_btn")) {
            $(this).trigger("click.subCategory");
            return;
          }

          if (e.type === "mousedown" && e.which === 3) return;

          e.preventDefault();

          const handler = getLongPressHandler(this);
          handler.start(e);
        }
      )

      .on(
        "mousemove.longpress touchmove.longpress",
        ".shop-product-container .shop-product",
        function (e) {
          if (isScrolling || hasScrolledDuringTouch) return;

          const handler = longPressHandlers.get(this);
          if (handler) {
            handler.move(e);
          }
        }
      )

      .on(
        "mouseup.longpress touchend.longpress",
        ".shop-product-container .shop-product",
        function (e) {
          if (isScrolling || hasScrolledDuringTouch) {
            setTimeout(() => {
              if (!isScrolling) {
                hasScrolledDuringTouch = false;
              }
            }, 100);
            return;
          }

          const handler = longPressHandlers.get(this);
          if (handler) {
            const wasLongPressed = handler.end();
            $(this).data("wasLongPressed", wasLongPressed);
          }
        }
      )

      .on(
        "mouseleave.longpress touchcancel.longpress",
        ".shop-product-container .shop-product",
        function () {
          const handler = longPressHandlers.get(this);
          if (handler) {
            handler.cancel();
          }
        }
      );

    $(document).on("hide.bs.modal", "#product-details-modal", function () {
      $(this).remove();
      $(".modal-backdrop").remove();
    });

    const lastAnimationTime = new WeakMap();

    function triggerShadowAnimation($button) {
      const element = $button[0];
      const now = Date.now();
      const lastTime = lastAnimationTime.get(element) || 0;

      if (now - lastTime < 200) return;

      lastAnimationTime.set(element, now);

      $button.addClass("animating shadow-animate");

      setTimeout(() => {
        $button.removeClass("shadow-animate animating");
      }, 200);
    }

    $(".shop-product").each(function () {
      lastAnimationTime.set(this, 0);
    });

    $(document).on(
      "click.product touchend.product",
      ".shop-product-container .shop-product",
      function (e) {
        // Prevent clicks during or after any scroll activity
        if (isScrolling || hasScrolledDuringTouch) {
          setTimeout(() => {
            if (!isScrolling) {
              hasScrolledDuringTouch = false;
            }
          }, 100);
          return;
        }

        e.stopPropagation();
        e.preventDefault();

        const $this = $(this);

        if ($this.data("wasLongPressed")) {
          $this.removeData("wasLongPressed");
          return;
        }

        triggerShadowAnimation($this);

        const isEnableDoubleClickQuickOrder = !!$("#product-list").data(
          "enable-double-click-quick-order"
        );

        if (
          isEnableDoubleClickQuickOrder &&
          !$("#open-cart").hasClass("d-none")
        ) {
          const existingTimer = $this.data("clickTimer");
          if (existingTimer) {
            clearTimeout(existingTimer);
          }

          const now = Date.now();
          const lastTap = $this.data("lastTap") || 0;
          const tapGap = now - lastTap;

          if (tapGap < 300 && tapGap > 50) {
            $this.trigger("dblclick");
            $this.removeData("lastTap");
            return;
          } else {
            $this.data("lastTap", now);
          }
        }

        const clickTimer = setTimeout(() => {
          if (!isScrolling && !hasScrolledDuringTouch) {
            const productContainer = $this.closest(".shop-product-container");
            $(".add-product", productContainer).trigger("click");
          }
          $this.removeData("clickTimer");
        }, 200);

        $this.data("clickTimer", clickTimer);
      }
    );

    $(window).on("beforeunload", function () {
      $(".shop-product-container .shop-product").each(function () {
        const handler = longPressHandlers.get(this);
        if (handler) {
          handler.cancel();
        }

        const clickTimer = $(this).data("clickTimer");
        if (clickTimer) {
          clearTimeout(clickTimer);
        }
      });

      if (scrollTimeout) {
        clearTimeout(scrollTimeout);
      }
    });

    $(window).on("unload", function () {
      $(window).off(".longpress");
      $(document).off(".longpress .scroll");
    });
  }
});
